








import Vue from 'vue'
import BaseText from '../atoms/BaseText.vue'

export default Vue.extend({
  components: {
    BaseText
  },
  computed: {
    month(): number | null {
      return this.$store.state.month
    },
  }
})
